import { StackView, Spinner, Text } from '@planningcenter/tapestry-react';
import React from 'react';
import { ScrollContainer } from '../../vendor/topbar/components/scroll_container.js';
import { ChildNotice } from '../child_notice.js';
import { Person } from '../person_list_item.js';
import { ErrorCard } from '../ui/error_card.js';
import { Subheading } from '../ui/subheading.js';
import { useNewGroupChatPeople } from './hooks/use_new_group_chat_people.js';

function People({ groupId }) {
    const { isLoading, isError, people, hasMore, totalCount } = useNewGroupChatPeople(groupId);
    const somePeople = people.length > 0;
    const childPeople = people.filter((p) => p.child);
    const someChildPeople = childPeople.length > 0;
    let title;
    switch (totalCount) {
        case null:
        case 0:
            title = "Members";
            break;
        case 1:
            title = "1 member";
            break;
        default:
            title = `${totalCount} members`;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
            React.createElement(Subheading, null, title),
            isLoading && React.createElement(Spinner, { size: "sm" })),
        isError && (React.createElement(ErrorCard, { marginBottom: 1, message: "There was an issue loading group members, please refresh and try again." })),
        somePeople && (React.createElement(React.Fragment, null,
            someChildPeople && React.createElement(ChildNotice, { childPeople: childPeople }),
            React.createElement(ScrollContainer, null,
                React.createElement(StackView, { paddingBottom: 2, spacing: 1.5 },
                    people.map((person) => (React.createElement(Person, { key: person.id, person: person }))),
                    hasMore && (React.createElement(Text, { color: "foregroundSecondary" },
                        "and ",
                        totalCount - people.length,
                        " more..."))))))));
}

export { People };
//# sourceMappingURL=people.js.map
